'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var ToggleBlockContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: 32px;\n  border-radius: 9px;\n  position: relative;\n  background-color: ", ";\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n  justify-content: space-around;\n  align-items: center;\n"], ["\n  height: 32px;\n  border-radius: 9px;\n  position: relative;\n  background-color: ", ";\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n  justify-content: space-around;\n  align-items: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedGreyBackground;
});
var ToggleBlockWrapper = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject([""], [""])));
var GhostToggleBlock = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  height: 32px;\n  border-radius: 9px;\n  box-sizing: border-box;\n  background-color: ", ";\n"], ["\n  height: 32px;\n  border-radius: 9px;\n  box-sizing: border-box;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var ToggleButton = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  position: relative;\n  text-align: center;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 20px;\n  color: ", ";\n  pointer-events: ", ";\n"], ["\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  position: relative;\n  text-align: center;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 20px;\n  color: ", ";\n  pointer-events: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return (disabled ? theme.colors.greys.sharedDarkGrey : theme.colors.universal.black);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'initial');
});
var ToggleButtonWrapper = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  cursor: ", ";\n  width: 50%;\n"], ["\n  cursor: ", ";\n  width: 50%;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var SwitchBlock = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  left: ", ";\n  top: 0;\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: 7px;\n  box-shadow: ", ";\n  transition: .5s;\n  cursor: ", ";\n"], ["\n  left: ", ";\n  top: 0;\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: 7px;\n  box-shadow: ", ";\n  transition: .5s;\n  cursor: ", ";\n"])), function (_a) {
    var isLeftActive = _a.isLeftActive;
    return (isLeftActive ? 0 : '50%');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedGreyBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.depth_1;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.GhostToggleBlock = GhostToggleBlock;
exports.SwitchBlock = SwitchBlock;
exports.ToggleBlockContainer = ToggleBlockContainer;
exports.ToggleBlockWrapper = ToggleBlockWrapper;
exports.ToggleButton = ToggleButton;
exports.ToggleButtonWrapper = ToggleButtonWrapper;
